module.exports = __webpack_public_path__ + "static/media/stack.97ec9dff.svg";